import React, { useState } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import { faqReviewScript } from "../../utils/additionalScriptHelpers"

const FaqReviewSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 850px) {
    margin-bottom: 1.3em;
  }
`

const FaqReviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const FaqReviewText = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  font-family: "Gotham Book";
  margin-bottom: 1.3em;
  text-align: center;
`

const FaqReviewBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0px 10px;
`

const Image = styled.img`
  width: 100%;
  margin: 0px;
  max-width: 35px;
`

const FaqSuccessBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const FaqReviewSection = ({ intl, data, title, sidebarKey }) => {
  const [success, setsuccess] = useState(false)
  const handleClick = (title, likeStatus) => {
    setsuccess(true)
    faqReviewScript(title, likeStatus, intl.locale)
  }
  return (
    data &&
    sidebarKey &&
    title && (
      <FaqReviewSectionWrapper>
        {!success ? (
          <FaqReviewWrapper>
            {data.faq_article_useful_title && (
              <FaqReviewText>{data.faq_article_useful_title}</FaqReviewText>
            )}
            <FaqReviewBox>
              <IconWrapper>
                <Image
                  className="lazyload"
                  data-src="https://static.percko.com/uploads/46e1b048-bf0f-4a6e-b6cc-f444dfcad83c.png"
                  onClick={() => handleClick(title, true)}
                />
              </IconWrapper>
              <IconWrapper>
                <Image
                  className="lazyload"
                  data-src="https://static.percko.com/uploads/f269ea9b-72dd-4dae-9afb-f6f16528e59c.png"
                  onClick={() => handleClick(title, false)}
                />
              </IconWrapper>
            </FaqReviewBox>
          </FaqReviewWrapper>
        ) : (
          <FaqSuccessBox>
            {data.faq_feedback_success && (
              <FaqReviewText>{data.faq_feedback_success}</FaqReviewText>
            )}
          </FaqSuccessBox>
        )}
      </FaqReviewSectionWrapper>
    )
  )
}

export default injectIntl(FaqReviewSection)
